<template>
  <div class="warpConss chat-list">
    <div
      v-for="(item, index) in CourseList"
      :key="item.id || index"
      class="chat-item"
    >
      <div class="item-title">
        <div class="flex-c ellipsis">
          <span @click="getSt(item)" class="title ellipsis">
            <i class="iconfont icon-a-Union21" />{{ item.liveChapterName }}
          </span>
          &nbsp;
          <span class="time">
            <span> 共{{ item.ksTime || 0 }}课时 </span>
          </span>
        </div>
        <div class="but-list">
          <div>
            <div
              v-if="item.whetherAttachment"
              class="keep-learn"
              @click.stop="goData(item, 1)"
            >
              随堂讲义
            </div>
            <div
              v-if="item.whetherPaper"
              class="keep-learn"
              @click.stop="cgeckTask(item)"
            >
              随堂测试
            </div>
            <div
              v-if="item.whetherMeans"
              class="keep-learn"
              @click.stop="goData(item, 2)"
            >
              随堂资料
            </div>
          </div>
        </div>
      </div>
    </div>
       <el-dialog width="45%" :visible.sync="questionBankVisible">
      <div v-if="detalilsList&&detalilsList.limitPlayLink" class="player-main">
        <jxyplayer
          :url="detalilsList.limitPlayLink"
          :options="option"
        />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import { getInfo } from "@/api/cookies";
import jxyplayer from "@/components/jxyPlay.vue";

export default {
    components: {
    jxyplayer,
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    playid: {
      type: String,
      default: "",
    },
    list: {
      type: Array,
      default: () => [],
    },
    classId: {
      type: String,
      default: "",
    },
    purchase: {
      type: Boolean,
      default: false,
    },
    ifClass: {
      type: Boolean,
      default: false,
    },
    isFreeze: {
      type: Number,
      default: 0,
    },
    cardCode: {
      type: String,
      default: "",
    },
    courseId: {
      type: String,
      default: "",
    },
     IsPurchase: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userInfo: null,
      CourseList: [],
      dialogVisible: false,
      questionBankVisible: false,
        option: {
        width: "100%",
        height: "100%",
        type: "HLS",
        aDType: "swiper",
      },
    };
  },

  created() {
    this.userInfo = getInfo();
    this.CourseList = this.list;
  },
  methods: {
        getSt(item) {
      console.log(item, "item");
      if (item.limitPlayLink) {
        this.questionBankVisible = true;
        this.detalilsList = item; 
      }
    },
    cgeckTask(item) {
        if (!this.IsPurchase) {
        this.$notify({
          title: "提示",
          message: "您还没有购买!",
          type: "warning",
        });
        return;
      }
      Vue.prototype.goExam(      {contactId:item.paperId,examType:6}      );
    },

    goData(item, type) { 
      const userInfo = getInfo();
      if (!userInfo) {
        Vue.prototype.goLoginView(false);
        return;
      }
        if (!this.IsPurchase) {
        this.$notify({
          title: "提示",
          message: "您还没有购买!",
          type: "warning",
        });
        return;
      }
 

      try {
        const params = new URLSearchParams({
          type: type,
          ChatId: item.liveChapterId,
          courseId: this.courseId,
        });
        window.open(`/data/dataPackageDetail?${params.toString()}`, "_blank");
      } catch (error) {
        console.error("打开资料详情失败:", error);
      }
    },
  },
};
</script>
<style lang="less" scoped>
// 缩宽
.warpConss {
  width: 100%;

  // height: 42px;
  .warpCpons {
    // position: absolute;
    position: fixed;
    z-index: 2000;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background: rgba(0, 0, 0, 0.6);

    div {
      width: 610px;
      height: auto;
      // margin-top: 400px;
      display: flex;
      z-index: 20;
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;
      background: rgba(255, 255, 255, 0);

      .imga {
        width: 100%;
        height: 420px;
      }

      .imgb {
        width: 36px;
        height: 36px;
        margin-top: 30px;
        cursor: pointer;
      }

      span {
        width: 100%;
        height: auto;
        text-align: center;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #6c90fe;
        margin-top: -160px;
      }
    }
  }

  // 单个内容展开项盒子
  .warpConskexqq {
    width: 100%;
    height: auto;
    background: #ffffff;
    padding: 30px 0px;

    .warpConskexq {
      width: 100%;
      height: auto;
      padding: 1px;

      // 某个展开项
      p {
        width: auto;
        height: 13px;
        font-size: 15px;
        margin: 20px 0px 30px 10px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #27323f;
      }

      .warpConskexqs {
        width: 1175px;
        height: 50px;
        margin: 10px auto;
        background: #f7f7f7;
        display: flex;
        justify-content: space-between;
        align-items: center;

        // 左侧
        .warpConskexqsL {
          width: auto;
          height: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          div {
            width: 4px;
            height: 50px;
            background: #dddddd;
            margin-right: 27px;
          }

          .on {
            background: rgb(107, 187, 251);
          }

          span {
            width: auto;
            height: auto;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            cursor: pointer;
          }
        }

        // 右侧
        .warpConskexqsR {
          width: 320px;
          height: 32px;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          div {
            width: 90px;
            height: 32px;
            margin-right: 10px;
            border-radius: 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.chat-list {
  padding: 0px 20px !important;

  .chat-item {
    margin: 0px auto;
    display: flex;
    align-items: center;
    width: 100%;
    height: 42px;
    padding: 0 20px !important;
    background: #f6f6f6;
    border-radius: 6px 6px 6px 6px;
    opacity: 1;
    margin-bottom: 10px;

    &:first-child {
      // margin-top: 20px;
    }

    &:last-child {
      margin-bottom: 20px;
    }

    .item-title {
      width: 100%;
      padding: 0;
      display: flex;
      cursor: pointer;
      align-items: center;
      justify-content: space-between;
      background: #f6f6f6;

      .flex-c {
        width: 550px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #333333;
      }

      .title {
        height: 26px;
        font-size: 16px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        // line-height: 14px;
        margin-right: 17px;

        .iconfont {
          display: inline-block;
          transform: translateY(2px);
          font-size: 18px;
          line-height: 10px;
          // margin-top: 3px !important;
          margin-right: 10px;
        }
      }

      .time {
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #666666;
        background: #fff;
        padding: 0 8px;
        // margin-left: 10px;
        // margin-top: 12px;
      }

      .tryListion {
        width: 48px;
        height: 20px;
        color: #ff5e51;
        background-color: #ffedeb;
        border-radius: 2px;
        font-size: 12px;
        line-height: 20px;
        text-align: center;
        margin-left: 20px;
      }

      /* 直播 */
      .liveIng {
        padding: 0px 4px;
        height: 20px;
        background: #ff5e51;
        border-radius: 4px 4px 4px 4px;
        font-size: 12px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
        margin-left: 8px;

        .live {
          color: #fff;
          font-size: 12px;
          margin-right: 4px;
        }
      }

      /* 回放 */
      .video {
        color: #6c7079;
        font-size: 40px;
      }
    }

    /* 未开始  回放生成中 */
    .noLive {
      color: #9fa4ad;

      .title,
      .time,
      .video {
        color: #9fa4ad !important;
      }
    }

    .but-list {
      flex-shrink: 0;
      display: flex;
      width: 300px;
      justify-content: flex-end;
      align-items: center;

      .keep-learn {
        margin-right: 10px;
        flex-shrink: 0;

        &:last-child {
          margin-right: 0px;
        }
      }
    }
  }

  .chat-item:last-child {
    margin-bottom: 20px;
  }
}

.lookBg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

  .ifLook {
    width: 500px;
    background-color: #fff;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #ccc;

    .contents {
      width: 380px;
      margin: 20px auto;

      & > span {
        color: red;
      }
    }

    .button {
      width: 120px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      border-radius: 10px;
      border: 1px solid #ccc;
      cursor: pointer;
    }
  }
}

/deep/ .terPic {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    // height: 100%;
    // border-radius: 50%;
  }
}
</style>
